<template>
  <v-container
    grid-list-xl
    fluid
  >
    <div>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
        >
          <v-alert
            :value="customer.errors.length"
            type="error"
            icon="new_releases"
            dismissible
          >
            <div v-html="customer.errorsText()"/>
          </v-alert>
        </v-flex>
        <v-flex
          xs12
          md8
        >
          <CustomerProfile :customer="customer" />
          <CustomerNewPassword :customer="customer" />
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <CustomerSubscriptions
            v-if="customer.email"
            :customer="customer"
          />
          <CustomerGroup
            :customer="customer"
            class="mb-4"
          />
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import {
  CustomerProfile,
  CustomerSubscriptions,
  CustomerAddressWidget,
  CustomerGroup
} from '../components/CustomerSingle'
import CustomerNewPassword from '../components/CustomerNew/CustomerNewPassword'

export default {
  name: 'CustomerNewPage',

  components: {
    CustomerGroup,
    CustomerSubscriptions,
    CustomerProfile,
    CustomerNewPassword,
    CustomerAddressWidget
  },

  async beforeRouteLeave (to, from, next) {
    if (this.customer && this.customer.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.customer.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'New Customer',
      actions: [
        {
          color: 'grey',
          text: 'Cancel',
          event: 'cancel'
        },
        {
          text: 'Create',
          event: 'create'
        }
      ]
    }
  },

  data () {
    return {
      customer: this.$http
        .make('customer', {
          firstname: '',
          lastname: '',
          telephone: null,
          dob: '',
          email: '',
          password: '',
          password_confirmation: '',
          generate_password: false,
          require_password_change: false,
          subscription: {
            email: true
          },
          group: {}
        }),
      countries: [],
      // TODO: hide button if nothing to save
      fields: ['personal', 'addresses']
    }
  },

  computed: {
    createActionStates () {
      return {
        disabled: !this.customer || this.customer.inProgress || !this.customer.isChanged || this.customer.errors.length,
        loading: !this.customer || this.customer.inProgress
      }
    },

    cancelActionStates () {
      return {
        disabled: !this.customer || this.customer.inProgress
      }
    }
  },

  methods: {
    onActionCancel () {
      this.$router.replace({ name: 'customers' })
    },

    async onActionCreate () {
      try {
        let data = {
          name: `${this.customer.firstname} ${this.customer.lastname}`,
          email: this.customer.email,
          type: 'customer',
          password: this.customer.password,
          password_confirmation: this.customer.password_confirmation,
          generate_password: this.customer.generate_password,
          require_password_change: this.customer.require_password_change
        }

        await this.customer.save()

        data.customer_id = this.customer.id
        await this.$http.make('auth:user', data).save()

        this.$router.push({
          name: 'single_customer',
          params: { id: this.customer.id }
        })
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      }
    }
  }
}
</script>
